import * as config from "Config";
import * as constants from "./constants";

export function clearStore(newObject) {
    return {
        type: constants.ORDER_CLEAR_STORE
    };
}


export function initOrderDetailData(params) {
    return {
        remote: {
            method: "get",
            url: config.apiUrl + "/api/Order/Company/" + params.companyId + "/" + params.orderId,
        },
        actions: [
            constants.ORDER_DETAIL_LOAD_START,
            constants.ORDER_DETAIL_LOAD_SUCCESS,
            constants.ORDER_DETAIL_LOAD_FAIL,
        ]
    };
}

export function initOrderEditData(params) {
    return {
        remote: {
            method: "get",
            url: config.apiUrl + "/api/Order/Company/" + params.companyId + "/" + params.orderId,
        },
        actions: [
            constants.ORDER_EDIT_LOAD_START,
            constants.ORDER_EDIT_LOAD_SUCCESS,
            constants.ORDER_EDIT_LOAD_FAIL,
        ]
    };
}

export function saveOrderEditData(params) {
    return {
        remote: {
            method: "post",
            url: config.apiUrl + "/api/Order/" + params.orderId + "/Company/" + params.companyId,
            data: params
        },
        actions: [
            constants.ORDER_EDIT_SAVE_START,
            constants.ORDER_EDIT_SAVE_SUCCESS,
            constants.ORDER_EDIT_SAVE_FAIL,
        ]
    };
}

export function initCustomerInfoByPhone(params) {
    return {
        remote: {
            method: "get",
            url: config.apiUrl + "/api/Customer/Company/" + params.companyId + "/" + params.phone,
        },
        actions: [
            constants.ORDER_CUSTOMER_INFO_LOAD_START,
            constants.ORDER_CUSTOMER_INFO_LOAD_SUCCESS,
            constants.ORDER_CUSTOMER_INFO_LOAD_FAIL,
        ]
    };
}


export function saveNewOrder(params) {
    return {
        remote: {
            method: "post",
            url: config.apiUrl + "/api/Order/Company/" + params.companyId,
            data: params
        },
        actions: [
            constants.ORDER_NEW_SAVE_START,
            constants.ORDER_NEW_SAVE_SUCCESS,
            constants.ORDER_NEW_SAVE_FAIL,
        ]
    };
}

export function saveOrderChangeStatus(params) {
    return {
        remote: {
            method: "PATCH",
            url: config.apiUrl + "/api/Order/Company/" + params.companyId + "/" + params.orderId,
            data: params
        },
        actions: [
            constants.ORDER_CHANGE_STATUS_START,
            constants.ORDER_CHANGE_STATUS_SUCCESS,
            constants.ORDER_CHANGE_STATUS_FAIL,
        ]
    };
}

export function initOrderPayment(params) {
    return {
        remote: {
            method: 'get',
            url: `${config.apiUrl}/api/Order/${params.orderId}/Company/${params.companyId}/Payment`,
            token: true,
        },
        actions: [
            constants.ORDER_PAYMENT_LOAD_START,
            constants.ORDER_PAYMENT_LOAD_SUCCESS,
            constants.ORDER_PAYMENT_LOAD_FAIL,
        ],
    };
}

export function saveOrderPayment(params) {
    return {
        remote: {
            method: 'post',
            url: `${config.apiUrl}/api/Order/${params.orderId}/Company/${params.companyId}/Payment`,
            data: params,
            token: true,
        },
        actions: [
            constants.ORDER_CHANGE_STATUS_START,
            constants.ORDER_CHANGE_STATUS_SUCCESS,
            constants.ORDER_CHANGE_STATUS_FAIL,
        ],
    };
}

export function saveOrderExternalPayment(params) {
    return {
        remote: {
            method: "post",
            url: `${config.apiUrl}/api/Order/${params.orderId}/Company/${params.companyId}/ExternalPayment`,
            data: params,
            token: true,
        },
        actions: [
            constants.itemSaveInvoiceStart,
            constants.itemSaveInvoiceSuccess,
            constants.itemSaveInvoiceFail,
        ],
    };
}

export function saveOrderExternalPaymentCheck(params) {
    return {
        remote: {
            method: "post",
            url: `${config.apiUrl}/api/Order/${params.orderId}/Company/${params.companyId}/CheckExternalPayment/${params.paymentId}`,
            data: params,
            token: true,
        },
        actions: [
            constants.itemCheckInvoiceStart,
            constants.itemCheckInvoiceSuccess,
            constants.itemCheckInvoiceFail,
        ],
    };
}

export function saveOrderPaymentConfirm(params) {
    return {
        remote: {
            method: "post",
            url: `${config.apiUrl}/api/Order/${params.orderId}/Company/${params.companyId}/ConfirmPayment/${params.paymentId}`,
            data: params,
            token: true,
        },
        actions: [
            constants.itemCheckInvoiceStart,
            constants.itemCheckInvoiceSuccess,
            constants.itemCheckInvoiceFail,
        ],
    };
}

export function saveOrderPaymentReject(params) {
    return {
        remote: {
            method: "post",
            url: `${config.apiUrl}/api/Order/${params.orderId}/Company/${params.companyId}/RejectPayment/${params.paymentId}`,
            data: params,
            token: true,
        },
        actions: [
            constants.itemCheckInvoiceStart,
            constants.itemCheckInvoiceSuccess,
            constants.itemCheckInvoiceFail,
        ],
    };
}

export function InitOrderList(params) {
    return {
        remote: {
            method: "get",
            url: config.apiUrl + "/api/Order/Company/" + params.companyId,
            data: params
        },
        actions: [
            constants.ORDER_LIST_LOAD_START,
            constants.ORDER_LIST_LOAD_SUCCESS,
            constants.ORDER_LIST_LOAD_FAIL,
        ]
    };
}

export function InitOrderListSummury(params) {
    return {
        remote: {
            method: "get",
            url: config.apiUrl + "/api/Order/Company/" + params.companyId + "/Summury",
            data: params
        },
        actions: [
            constants.ORDER_LIST_SUMMURY_LOAD_START,
            constants.ORDER_LIST_SUMMURY_LOAD_SUCCESS,
            constants.ORDER_LIST_SUMMURY_LOAD_FAIL,
        ]
    };
}

export function initCategoryList(params) {
    let url = config.apiUrl + "/api/Category";
    if (params.companyId) {
        url += "/Company/" + params.companyId;
    }
    if (params.companyGroupId) {
        url += "/CompanyGroup/" + params.companyGroupId;
    }

    return {
        remote: {
            method: "get",
            url: url
        },
        actions: [
            constants.CATEGORY_LIST_LOAD_START,
            constants.CATEGORY_LIST_LOAD_SUCCESS,
            constants.CATEGORY_LIST_LOAD_FAIL,
        ]
    };
}

export function initItemList(params) {
    let url = config.apiUrl + "/api/Item";
    if (params.companyId) {
        url += "/Company/" + params.companyId;
    }
    if (params.companyGroupId) {
        url += "/CompanyGroup/" + params.companyGroupId;
    }

    return {
        remote: {
            method: "get",
            url: url
        },
        actions: [
            constants.ITEM_LIST_LOAD_START,
            constants.ITEM_LIST_LOAD_SUCCESS,
            constants.ITEM_LIST_LOAD_FAIL,
        ]
    };
}

export function initStatusOrderList(params) {
    return {
        remote: {
            method: "get",
            url: config.apiUrl + "/api/OrderStatus/Company/" + params.companyId
        },
        actions: [
            constants.ORDER_STATUS_LIST_LOAD_START,
            constants.ORDER_STATUS_LIST_LOAD_SUCCESS,
            constants.ORDER_STATUS_LIST_LOAD_FAIL,
        ]
    };
}

export function initTagList(params) {
    let url = config.apiUrl + "/api/Tag";
    if (params.companyId) {
        url += "/Company/" + params.companyId;
    }
    if (params.companyGroupId) {
        url += "/CompanyGroup/" + params.companyGroupId;
    }

    return {
        remote: {
            method: "get",
            url
        },
        actions: [
            constants.TAG_LIST_LOAD_START,
            constants.TAG_LIST_LOAD_SUCCESS,
            constants.TAG_LIST_LOAD_FAIL,
        ]
    };
}

export function initDiscountList(params) {
    let url = config.apiUrl + "/api/Discount";
    if (params.companyId) {
        url += "/Company/" + params.companyId;
    }
    if (params.companyGroupId) {
        url += "/CompanyGroup/" + params.companyGroupId;
    }

    return {
        remote: {
            method: "get",
            url,
            data: params
        },
        actions: [
            constants.DISCOUNT_LIST_LOAD_START,
            constants.DISCOUNT_LIST_LOAD_SUCCESS,
            constants.DISCOUNT_LIST_LOAD_FAIL,
        ]
    };
}

export function printPreBill(params) {
    return {
        remote: {
            method: "post",
            url: `${config.apiUrl}/PreBill/Company/${params.companyId}/${params.orderId}`
        },
        actions: ["none", "none", "none"]
    };
}

export function printKitchen(params) {
    return {
        remote: {
            method: "post",
            url: `${config.apiUrl}/PreBill/Company/${params.companyId}/${params.orderId}/Kitchen`
        },
        actions: ["none", "none", "none"]
    };
}

export function printUsedStockItems(params) {
    return {
        remote: {
            method: "post",
            url: `${config.apiUrl}/PreBill/Company/${params.companyId}/${params.orderId}/UsedStockItems`
        },
        actions: ["none", "none", "none"]
    };
}


export function initItemHistory(params) {
    return {
        remote: {
            method: "get",
            url: config.apiUrl + "/api/OrderHistory/" + params.orderId + "/Company/" + params.companyId
        },
        actions: [
            constants.ITEM_HISTORY_LOAD_START,
            constants.ITEM_HISTORY_LOAD_SUCCESS,
            constants.ITEM_HISTORY_LOAD_FAIL,
        ]
    };
}

export function initPrimeCost(params) {
    return {
        remote: {
            method: "get",
            url: config.apiUrl + "/api/Order/Company/" + params.companyId + "/" + params.orderId + "/PrimeCost"
        },
        actions: [
            constants.itemPrimeCostLoadStart,
            constants.itemPrimeCostLoadSuccess,
            constants.itemPrimeCostLoadFail,
        ]
    };
}

export function moveOrderToCompany(params) {
    return {
        remote: {
            method: "post",
            url: `${config.apiUrl}/api/Order/${params.orderId}/Company/${params.companyId}/Move`,
            data: params,
            token: true,
        },
        actions: [
            constants.itemCheckInvoiceStart,
            constants.itemCheckInvoiceSuccess,
            constants.itemCheckInvoiceFail,
        ],
    };
}
